import React from 'react';
import { AlertBell } from '@yme/assets/icons';
import { AlertType } from '@yme/atoms/alert';
import { NotifyMeCurrentButton } from './NotifyMeCurrentButton';
import { getNotifyMeAlertMessage } from './helpers';
import { AlertStyled } from './styled';
export function NotifyMeControl(props) {
    const { NotifyMeType, isRightToLeft, notifyMeLabels, productNotifyMeDisclaimer } = props;
    const notifyAlertMessage = getNotifyMeAlertMessage(NotifyMeType, notifyMeLabels, productNotifyMeDisclaimer);
    return (React.createElement(AlertStyled, { message: notifyAlertMessage, type: AlertType.WARNING, customIcon: AlertBell, isRightToLeft: isRightToLeft, action: React.createElement(NotifyMeCurrentButton, { ...props }) }));
}
